var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.78413 7.44807L4.25827 12.6077C3.97038 12.9361 3.5036 12.9361 3.21584 12.6077C2.92805 12.2796 2.92805 11.7475 3.21584 11.4194L7.22052 6.85392L3.21595 2.28858C2.92817 1.96035 2.92817 1.42827 3.21595 1.10017C3.50374 0.771947 3.97049 0.771947 4.25839 1.10017L8.78424 6.2599C8.92814 6.42403 9 6.63891 9 6.85389C9 7.06898 8.928 7.28402 8.78413 7.44807Z","fill":"#E20000"}));
}

ArrowRight.defaultProps = {"width":"12","height":"13","viewBox":"0 0 12 13","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
